import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Developer",
          "Tech Enthusiast",
          // "Aspiring Software Engineer",
          "Problem Solver",
          "Lifelong Learner",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
        delay: 80,
        cursor: "|",
      }}
    />
  );
}

export default Type;